/**
 * @flow
 * @relayHash bb5a84302d04406b2076b138f791221b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SolicitationQuickView_solicitation$ref = any;
type SolicitationsList_solicitations$ref = any;
type SolicitationsList_stateTypes$ref = any;
export type SolicitationsPageQueryVariables = {|
  first?: ?number,
  orderBy?: ?string,
  after?: ?string,
  id: string,
  subject?: ?string,
  staffCoordinator?: ?string,
  organization?: ?string,
  dateReceivedFrom?: ?any,
  dateReceivedTo?: ?any,
  replyByFrom?: ?any,
  replyByTo?: ?any,
|};
export type SolicitationsPageQueryResponse = {|
  +__type: ?{|
    +$fragmentRefs: SolicitationsList_stateTypes$ref
  |},
  +$fragmentRefs: SolicitationsList_solicitations$ref & SolicitationQuickView_solicitation$ref,
|};
export type SolicitationsPageQuery = {|
  variables: SolicitationsPageQueryVariables,
  response: SolicitationsPageQueryResponse,
|};
*/


/*
query SolicitationsPageQuery(
  $first: Int
  $after: String
  $subject: String
  $staffCoordinator: ID
  $organization: String
  $dateReceivedFrom: Date
  $dateReceivedTo: Date
  $replyByFrom: Date
  $replyByTo: Date
) {
  ...SolicitationsList_solicitations_Iga8b
  __type(name: "SolicitationState") {
    ...SolicitationsList_stateTypes
  }
  ...SolicitationQuickView_solicitation
}

fragment SolicitationsList_solicitations_Iga8b on Query {
  allSolicitations(first: $first, orderBy: "-dateSent", after: $after, subject: $subject, staffCoordinator: $staffCoordinator, organization: $organization, dateReceivedFrom: $dateReceivedFrom, dateReceivedTo: $dateReceivedTo, replyByFrom: $replyByFrom, replyByTo: $replyByTo) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edgeCount
    edges {
      node {
        id
        solicitationId
        subject
        replyByDate
        dateSent
        staffCoordinator {
          fullName
          representativeImageUrl
          organization {
            name
            representativeImageUrl
            id
          }
          id
        }
        state
      }
    }
  }
}

fragment SolicitationsList_stateTypes on __Type {
  enumValues {
    name
    description
  }
}

fragment SolicitationQuickView_solicitation on Query {
  solicitation(id: "") {
    subject
    message
    ...SolicitationCommentThread_solicitation_3lORDC
    id
  }
}

fragment SolicitationCommentThread_solicitation_3lORDC on SolicitationNode {
  solicitationId
  state
  comments {
    edges {
      node {
        id
        content
        created
        contentEditedAt
        repliedTo {
          content
          created
          user {
            fullName
            id
          }
        }
        contractor {
          fullName
          representativeImageUrl
          freelancer {
            user {
              id
            }
            id
          }
          id
        }
        createdByStaff {
          fullName
          representativeImageUrl
          user {
            id
          }
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "subject",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "staffCoordinator",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "organization",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dateReceivedFrom",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dateReceivedTo",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "replyByFrom",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "replyByTo",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "SolicitationState"
  }
],
v2 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v3 = {
  "kind": "Variable",
  "name": "dateReceivedFrom",
  "variableName": "dateReceivedFrom"
},
v4 = {
  "kind": "Variable",
  "name": "dateReceivedTo",
  "variableName": "dateReceivedTo"
},
v5 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v6 = {
  "kind": "Variable",
  "name": "organization",
  "variableName": "organization"
},
v7 = {
  "kind": "Variable",
  "name": "replyByFrom",
  "variableName": "replyByFrom"
},
v8 = {
  "kind": "Variable",
  "name": "replyByTo",
  "variableName": "replyByTo"
},
v9 = {
  "kind": "Variable",
  "name": "staffCoordinator",
  "variableName": "staffCoordinator"
},
v10 = {
  "kind": "Variable",
  "name": "subject",
  "variableName": "subject"
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "solicitationId",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subject",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "representativeImageUrl",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "content",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "user",
  "storageKey": null,
  "args": null,
  "concreteType": "UserNode",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SolicitationsPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "__type",
        "storageKey": "__type(name:\"SolicitationState\")",
        "args": (v1/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SolicitationsList_stateTypes",
            "args": null
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "SolicitationsList_solicitations",
        "args": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "SolicitationQuickView_solicitation",
        "args": null
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SolicitationsPageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allSolicitations",
        "storageKey": null,
        "args": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": "-dateSent"
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "concreteType": "SolicitationNodeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "edgeCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "SolicitationNodeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "SolicitationNode",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "replyByDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dateSent",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "staffCoordinator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StaffNode",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "organization",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrgNode",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v15/*: any*/),
                          (v11/*: any*/)
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "__type",
        "storageKey": "__type(name:\"SolicitationState\")",
        "args": (v1/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "enumValues",
            "storageKey": null,
            "args": null,
            "concreteType": "__EnumValue",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "solicitation",
        "storageKey": "solicitation(id:\"\")",
        "args": [
          {
            "kind": "Literal",
            "name": "id",
            "value": ""
          }
        ],
        "concreteType": "SolicitationNode",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          (v12/*: any*/),
          (v17/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "comments",
            "storageKey": null,
            "args": null,
            "concreteType": "SolicitationContractorLogNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SolicitationContractorLogNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SolicitationContractorLogNode",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "contentEditedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "repliedTo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CommentRepliedToNode",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contractor",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractorNode",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "freelancer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FreelancerNode",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v11/*: any*/)
                            ]
                          },
                          (v11/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "createdByStaff",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StaffNode",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v20/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SolicitationsPageQuery",
    "id": null,
    "text": "query SolicitationsPageQuery(\n  $first: Int\n  $after: String\n  $subject: String\n  $staffCoordinator: ID\n  $organization: String\n  $dateReceivedFrom: Date\n  $dateReceivedTo: Date\n  $replyByFrom: Date\n  $replyByTo: Date\n) {\n  ...SolicitationsList_solicitations_Iga8b\n  __type(name: \"SolicitationState\") {\n    ...SolicitationsList_stateTypes\n  }\n  ...SolicitationQuickView_solicitation\n}\n\nfragment SolicitationsList_solicitations_Iga8b on Query {\n  allSolicitations(first: $first, orderBy: \"-dateSent\", after: $after, subject: $subject, staffCoordinator: $staffCoordinator, organization: $organization, dateReceivedFrom: $dateReceivedFrom, dateReceivedTo: $dateReceivedTo, replyByFrom: $replyByFrom, replyByTo: $replyByTo) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n    edgeCount\n    edges {\n      node {\n        id\n        solicitationId\n        subject\n        replyByDate\n        dateSent\n        staffCoordinator {\n          fullName\n          representativeImageUrl\n          organization {\n            name\n            representativeImageUrl\n            id\n          }\n          id\n        }\n        state\n      }\n    }\n  }\n}\n\nfragment SolicitationsList_stateTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n\nfragment SolicitationQuickView_solicitation on Query {\n  solicitation(id: \"\") {\n    subject\n    message\n    ...SolicitationCommentThread_solicitation_3lORDC\n    id\n  }\n}\n\nfragment SolicitationCommentThread_solicitation_3lORDC on SolicitationNode {\n  solicitationId\n  state\n  comments {\n    edges {\n      node {\n        id\n        content\n        created\n        contentEditedAt\n        repliedTo {\n          content\n          created\n          user {\n            fullName\n            id\n          }\n        }\n        contractor {\n          fullName\n          representativeImageUrl\n          freelancer {\n            user {\n              id\n            }\n            id\n          }\n          id\n        }\n        createdByStaff {\n          fullName\n          representativeImageUrl\n          user {\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0cddd500eced63eaa588ecd6d92e3a9e';
module.exports = node;
